import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AnimatedText from "../anim/AnimatedText";
import useMediaQuery from "../../hooks/useMediaQuery";
import posts from "../../data/posts.json";

const listVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08, delayChildren: 0.2 } },
};

const rowVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const PostRow = ({ post, aboveMediumScreens }) => (
  <motion.div variants={rowVariants}>
    <Link
      to={`/blog/${post.slug}`}
      className="group block border-b border-semi-black"
    >
      {aboveMediumScreens ? (
        <div className="flex items-start justify-between gap-16 py-10">
          <div className="max-w-[70%]">
            <p
              className="font-satoshi text-5xl transition-colors duration-300
              group-hover:text-blue"
            >
              {post.title}
            </p>
            {post.summary && (
              <p className="mt-5 font-satoshi text-xl font-normal text-clay">
                {post.summary}
              </p>
            )}
          </div>
          <p className="mt-3 font-satoshi text-base font-normal text-clay-2 whitespace-nowrap">
            {post.dateLabel}
          </p>
        </div>
      ) : (
        /* MOBILE */
        <div className="py-7">
          <p className="font-satoshi text-base font-normal text-clay-2">
            {post.dateLabel}
          </p>
          <p className="mt-2 font-satoshi text-2xl">{post.title}</p>
          {post.summary && (
            <p className="mt-3 font-satoshi text-base font-normal text-clay">
              {post.summary}
            </p>
          )}
        </div>
      )}
    </Link>
  </motion.div>
);

const BlogIndex = () => {
  const aboveMediumScreens = useMediaQuery("(min-width: 1061px)");

  return (
    <>
      {aboveMediumScreens ? (
        <section
          className="min-h-screen mt-[72px] pb-24 relative overflow-hidden
          bg-off-black pt-16"
        >
          <div
            className="px-[7%] text-off-white text-9xl
          font-generalsans font-extrabold"
          >
            <AnimatedText text={"Blog /"} />
            <motion.div
              className="mt-16 border-t border-semi-black"
              variants={listVariants}
              initial="hidden"
              animate="visible"
            >
              {posts.map((post) => (
                <PostRow key={post.slug} post={post} aboveMediumScreens />
              ))}
              {posts.length === 0 && (
                <p className="font-satoshi text-2xl font-normal text-clay">
                  Nothing published yet. Check back soon.
                </p>
              )}
            </motion.div>
          </div>
        </section>
      ) : (
        /* MOBILE */
        <section
          className="min-h-screen mt-[41px] pb-24 overflow-hidden relative
          bg-off-black pt-12"
        >
          <div className="px-6 text-off-white text-5xl font-generalsans font-extrabold">
            <AnimatedText className="text-center" text={"Blog /"} />
            <motion.div
              className="mt-8 border-t border-semi-black"
              variants={listVariants}
              initial="hidden"
              animate="visible"
            >
              {posts.map((post) => (
                <PostRow
                  key={post.slug}
                  post={post}
                  aboveMediumScreens={false}
                />
              ))}
              {posts.length === 0 && (
                <p className="font-satoshi text-lg font-normal text-clay">
                  Nothing published yet. Check back soon.
                </p>
              )}
            </motion.div>
          </div>
        </section>
      )}
    </>
  );
};

export default BlogIndex;
